// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Pārvietots ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => p['label'] + ' darbība pabeigta',
  accButtonProgressStatus: (p: { label: string }) => 'Pašlaik notiek ' + p['label'] + ' darbība',
  accColorPalette: () => 'Krāsu palete',
  accColorSwatch: () => 'Krāsu palete',
  accCommandKey: () => 'Komanda',
  accContextMenuLabel: () => 'darbības',
  accControlKey: () => 'Aizvērt',
  accPositionAfter: () => 'pēc',
  accPositionBefore: () => 'pirms',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Nospiediet un turiet taustiņu ' +
    p['keyPressed'] +
    ' un Shift, pēc tam izmantojiet bulttaustiņus, lai pārkārtotu.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Ievadiet pilnu datumu šādi: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Ievadiet mēnesi un gadu šādi: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Etiķete',
  chart_labelGroup: () => 'Grupa',
  chart_labelSeries: () => 'Sērija',
  chart_labelValue: () => 'Vērtība',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Atlasiet vērtību.',
  checkbox_helpForCheckbox: () => 'Palīdzība saistībā ar izvēles rūtiņu',
  checkbox_requiredMessageDetail: () => 'Atlasiet vērtību.',
  checkbox_selected: () => 'Izvēles rūtiņa ir atlasīta',
  checkbox_unselected: () => 'Izvēles rūtiņa nav atlasīta',
  close: () => 'Aizvērt',
  collection_apply: () => 'Lietot',
  collection_cancel: () => 'Atcelt',
  collection_loaded: () => 'Ielādēts',
  collection_loading: () => 'Ielādē',
  collection_noData: () => 'Nav parādāmu datu.',
  collection_pixels: () => 'piks.',
  collection_resizeColumnDialog: () => 'Mainīt kolonnas izmērus',
  collection_resizeColumnMenu: () => 'Mainīt kolonnas izmērus...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Ievadiet skaitli no ' + p['MIN'] + ' līdz ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Atlasīt visas rindas',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Atlasīt rindu ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'Augošā secībā',
  collection_sortColumnMenu: () => 'Kārtot kolonnu',
  collection_sortDescendingSubMenu: () => 'Dilstošā secībā',
  collection_sortDisabled: () => 'Nav kārtojams',
  collection_sortEnabled: () => 'Kārtojams',
  collection_width: () => 'Platums',
  colorPicker_label: () => 'Krāsu atlasītājs',
  confirmation: () => 'Apstiprinājums',
  datePicker_currentDate: () => 'Pašreizējais datums',
  datePicker_goToToday: () => 'Uz šodienu',
  datePicker_label: () => 'Datuma atlasītājs',
  datePicker_month: () => 'Mēnesis',
  datePicker_months: () => 'Mēneši',
  datePicker_next: () => 'Tālāk',
  datePicker_nextDecade: () => 'Nākamā dekāde',
  datePicker_nextMonth: () => 'Nākamais mēnesis',
  datePicker_prev: () => 'Atpakaļ',
  datePicker_prevDecade: () => 'Iepriekšējā dekāde',
  datePicker_prevMonth: () => 'Iepriekšējais mēnesis',
  datePicker_restricted: () => 'Ierobežots',
  datePicker_selected: () => 'Atlasīts',
  datePicker_today: () => 'Šodien',
  datePicker_weekNum: (p: { NUM: string }) => p['NUM'] + '. nedēļa',
  datePicker_weekNumColLabel: () => 'Nedēļas numurs',
  datePicker_year: () => 'Gads',
  datePicker_years: () => 'Gadi',
  diagram_promotedLink: () => '1 saite',
  diagram_promotedLinkAriaDesc: () => 'Netiešs',
  diagram_promotedLinks: (p: { num_links: string }) => p['num_links'] + ' saites',
  error: () => 'Kļūda',
  expandableList_expandCollapseInstructionText: () =>
    'Izmantojiet bulttaustiņus, lai izvērstu un sakļautu',
  expandableList_groupCollapse: () => 'Sakļauts',
  expandableList_groupExpand: () => 'Izvērsts',
  filePicker_addFiles: () => 'Pievienot failus',
  filePicker_dropzonePrimaryText: () => 'Velciet un nometiet',
  filePicker_dropzoneSecondaryText: () => 'Atlasiet failu vai nometiet to šeit',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Atlasiet vai nometiet šeit failus',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nevar augšupielādēt failus ar tipu: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Augšupielādējiet pa vienam failam',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nevar augšupielādēt failus ar tipu ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'nezināms',
  formControl_clear: () => 'Notīrīt',
  formControl_day: () => 'Diena',
  formControl_empty_segment: () => 'Tukšs',
  formControl_helpAvailable: () => 'Palīdzība pieejama',
  formControl_hide: () => 'Paslēpt',
  formControl_hour: () => 'Stunda',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Ir sasniegts ' +
    ((
      {
        zero: new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmju',
        one: new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmes'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('lv').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('lv').format(p['CHARACTER_LIMIT']) + ' rakstzīmju') +
    ' ierobežojums.',
  formControl_loading: () => 'Ielādē',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Var ievadīt ne vairāk kā ' + p['MAX_LENGTH'] + ' rakstzīmes.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Pārsniegts maksimālais garums ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Atlikušas ' + p['CHARACTER_COUNT'] + ' rakstzīmes.',
  formControl_millisecond: () => 'Milisekunde',
  formControl_minute: () => 'Minūte',
  formControl_month: () => 'Mēnesis',
  formControl_readOnly: () => 'Tikai lasāms',
  formControl_requiredMessageDetail: () => 'Ievadiet vērtību.',
  formControl_second: () => 'Sekunde',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Atlasiet ' + p['n'] + ' vērtības.',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Ir sasniegts atlases ierobežojums: ' + p['max'] + '.',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Atlasiet no ' + p['min'] + ' līdz ' + p['max'] + ' vērtībām.',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Atlasiet vismaz ' + p['min'] + ' vērtības.',
  formControl_show: () => 'Rādīt',
  formControl_year: () => 'Gads',
  gantt_labelDate: () => 'Datums',
  gantt_labelEnd: () => 'Beigt',
  gantt_labelLabel: () => 'Etiķete',
  gantt_labelRow: () => 'Rinda',
  gantt_labelStart: () => 'Sākt',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nav atrasta neviema atbilstoša sadaļa.',
  indexer_keyboardInstructionText: () => 'Nospiediet Enter, lai atlasītu vērtību.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Starp ' + p['FROM_SECTION'] + ' un ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Divreiz pieskarieties un turiet, lai ieietu žestu režīmā, tad velciet uz augšu vai uz leju, lai pielāgotu vērtību.',
  info: () => 'Informācija',
  inputColor_selectColor: () => 'Atlasiet krāsu',
  inputDateMask_date_cleared: () => 'Dzēšanas datums',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tukšs',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'gggg',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ievadiet datumu, kas ir ' + p['max'] + ' vai agrāk.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ievadiet datumu, kas ir ' + p['min'] + ' vai vēlāk.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Ievadiet pieejamu datumu.',
  inputDatePicker_instruction: () => 'Nospiediet Tab, lai piekļūtu kalendāram.',
  inputDatePicker_selectDate: () => 'Atlasīt datumu',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ievadiet mēnesi un gadu, kas ir ' + p['max'] + ' vai pirms tam.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ievadiet mēnesi un gadu, kas ir ' + p['min'] + ' vai pēc tam tam.',
  inputNumber_converterParseError: () => 'Ievadīt skaitli.',
  inputNumber_decrease: () => 'Samazināt',
  inputNumber_increase: () => 'Palielināt',
  inputPassword_hidden: () => 'Parole paslēpta',
  inputPassword_hide: () => 'Paslēpt paroli',
  inputPassword_show: () => 'Rādīt paroli',
  inputSensitiveText_hidden: () => 'Slepenais teksts ir paslēpts',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Ievadiet laiku, kas ir ' + p['max'] + ' vai agrāk.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Ievadiet laiku, kas ir ' + p['min'] + ' vai vēlāk.',
  inputTimeMask_time_cleared: () => 'Laiks notīrīts',
  labelNone: () => 'Nav',
  list_msgFetchCompleted: () => 'Ielādēts',
  list_msgFetchingData: () => 'Ielādē',
  list_suggestion: () => 'Priekšlikums',
  menu_stateLoading: () => 'Ielādē',
  messageToast_allMessagesClosed: () => 'Visi uznirstošie ziņojumi ir aizvērti.',
  message_close: () => 'Aizvērt',
  message_confirmation: () => 'Veiksmīgi',
  message_error: () => 'Kļūda',
  message_info: () => 'Informācija',
  message_navigationFromMessagesRegion: () =>
    'Atver ziņojumu apgabalu. Nospiediet taustiņu F6, lai pārskatītu.',
  message_navigationToMessagesRegion: () =>
    'Ziņojumu apgabalā ir jauni ziņojumi. Nospiediet F6, lai naviģētu.',
  message_navigationToTouch: () => 'Ziņojumu apgabalā ir jauni ziņojumi.',
  message_warning: () => 'Brīdinājums',
  noData_message: () => 'Nav vienumu, ko parādīt',
  overflowItemLabel: () => 'Papildu cilnes',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Divreiz pieskarieties, lai aizvērtu atvērto uznirstošo logu.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Notiek ieiešana uznirstošajā logā. Nospiediet F6, lai naviģētu starp uznirstošo logu un saistīto vadīklu.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Uznirstošais logs ir atvērts. Nospiediet F6, lai naviģētu starp uznirstošo logu un saistīto vadīklu.',
  progressIndeterminate: () => 'Pašlaik notiek',
  radioButton_checked: () => 'Radiopoga atzīmēta',
  radioButton_selected: () => 'Radiopoga atlasīta',
  radioButton_unchecked: () => 'Radiopoga nav atzīmēta',
  radioButton_unselected: () => 'Radiopoga nav atlasīta',
  radio_helpForRadio: () => 'Radiopogas palīdzība',
  radio_requiredMessageDetail: () => 'Atlasiet vērtību.',
  selectMultiple_apply: () => 'Lietot',
  selectMultiple_back: () => 'Atpakaļ',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Izmantojiet pa labi un pa kreisi vērsto bultiņu taustiņus, lai iezīmētu atlasītās vērtības.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Nospiediet atpakaļatkāpes taustiņu vai Delete, lai noņemtu atlasīto vērtību.',
  selectMultiple_selectedValues: () => 'Atlasītās vērtības',
  selectMultiple_showSelectedValues: () => 'Rādīt tikai atlasītās vērtības.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Atlasītas ' + p['VALUE_COUNT'] + ' vērtības.',
  select_addToList: () => 'Pievienot sarakstam',
  select_addToListAvailable: () => 'Pievienot pieejamam sarakstam',
  select_closeDropdown: () => 'Nospiediet Escape, lai aizvērtu.',
  select_moreSearchOptions: () => 'Vairāk meklēšanas opciju',
  select_moreSearchOptionsAvailable: () => 'Pieejamas papildu meklēšanas opcijas',
  select_noMatchesFound: () => 'Nav atrasta neviena atbilstība.',
  select_oneMatchFound: () => 'Atrasta viena atbilstība',
  select_requiredMessageDetail: () => 'Atlasiet vērtību.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' atbilstības',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Atrastas ' + p['TOTAL_SIZE'] + ' vai vairāk atbilstību',
  selectorAll_deselectAll: () => 'Noņemt visa atlasi',
  selectorAll_selectAll: () => 'Atlasīt visu',
  selector_selected: () => 'Izvēles rūtiņa ir atlasīta',
  selector_unselected: () => 'Izvēles rūtiņa nav atlasīta',
  sheet_close: () => 'Aizvērt',
  switch_off: () => 'Izslēgt',
  switch_on: () => 'Ieslēgts',
  tabBarNavigationList_removeCueText: () => 'Noņemams',
  tabBar_tabContainsErrors: () => 'Ir radušās kļūdas',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Noņēma ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'ir kontekstizvēlne',
  tabbar_labelMoveLeft: () => 'Pārvietot pa kreisi',
  tabbar_labelMoveRight: () => 'Pārvietot pa labi',
  tabbar_labelRemove: () => 'Noņemt',
  timeComponent_tooltipZoomIn: () => 'Tuvināt',
  timeComponent_tooltipZoomOut: () => 'Tālināt',
  timeConverter_parseError: () => 'Ievadiet pilnu laiku.',
  train_current: () => 'Pašreizējais',
  train_message_type: () => 'Ziņojuma tips',
  train_not_visited: () => 'Nav apmeklēts',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Darbība ' + p['currentStep'] + ' no ' + p['numberOfSteps'],
  train_visited: () => 'Apmeklēts',
  userAssistance_learnMore: () => 'Uzzināt vairāk',
  userAssistance_required: () => 'Nepieciešams',
  vis_clearSelection: () => 'Notīrīt atlasi',
  vis_drillable: () => 'Detalizējams',
  vis_invalidData: () => 'Nederīgi dati',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' no ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Slīdošā teksta atlase',
  vis_marqueeZoomTooltip: () => 'Slīdošā teksta tālummaiņa',
  vis_noData: () => 'Nav parādāmu datu',
  vis_panTooltip: () => 'Panoramēt',
  vis_stateCollapsed: () => 'Sakļauts',
  vis_stateExpanded: () => 'Izvērsts',
  vis_stateLoaded: () => 'Ielādēts',
  vis_stateLoading: () => 'Ielādē',
  vis_stateSelected: () => 'Atlasīts',
  vis_stateUnselected: () => 'Neatlasīts',
  warn: () => 'Brīdinājums'
};
export default bundle;
